import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { AtlassianJiraConfluenceGridDataProviderFactory } from '../factory/AtlassianJiraConfluenceGridDataProviderFactory';
import { AtlassianJiraConfluenceGridBaseDataProvider } from '../dataProvider/AtlassianJiraConfluenceGridBaseDataProvider';
import { AtlassianJiraConfluenceGridViewData } from '../types';

export class AtlassianJiraConfluenceGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: AtlassianJiraConfluenceGridDataProviderFactory;
  public dataProvider: AtlassianJiraConfluenceGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new AtlassianJiraConfluenceGridDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<AtlassianJiraConfluenceGridViewData> {
    return await this.dataProvider.getDataForView();
  }
}
